import React from "react";
import '../../../styles/components/onboarding/info/info-navigation.scss';
import NavigationDots from "../../common/NavigationDots";
import Button from "../../common/Button";
import {useTrialNavigation} from "../../../hooks/trialNavigation.hook";

export default function InfoNavigation({currentIndex, onNextClick}: {currentIndex: number, onNextClick: ()=> void}) {
  const {navigateToAppropriateAccountCreationPage} = useTrialNavigation();

  return (
    <div className="info-navigation">
      <NavigationDots totalDots={4} currentIndex={currentIndex}/>
      <div className="buttons">
        <Button text={"Skip Intro"} buttonType={"secondary"} onClick={()=>{
          navigateToAppropriateAccountCreationPage();
        }}/>
        <Button text={"Next"} onClick={onNextClick}/>
      </div>
    </div>
  );
}
